import { render, staticRenderFns } from "./troubleshooter.vue?vue&type=template&id=0fa139c8&scoped=true&"
import script from "./troubleshooter.vue?vue&type=script&lang=js&"
export * from "./troubleshooter.vue?vue&type=script&lang=js&"
import style0 from "./troubleshooter.vue?vue&type=style&index=0&id=0fa139c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa139c8",
  null
  
)

export default component.exports